import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import {
  WebPortalIndustryAutomative,
  WebPortalIndustryFintech,
  WebPortalIndustryCann,
  EcommerceWebIndustryHealthcare,
  WebPortalIndustryHospitality,
  WebPortalIndustryInsurance,
} from "../../../app-constants";

function Ecommerceindustries() {
  return (
    <section
      className="web_portal_industries p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={9}
            xl={8}
            xxl={7}
            className="m-auto text-center"
          >
            <h2>
              Industries We Serve with <span>Our Web Portal </span>Solutions
            </h2>
            <p>
              Web portal precisely built to cater to your specific business
              requirements. We are experts in facilitating diverse industries
              based on the variable nature of business with our web portal
              development services:
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="ecommerce_industries_main">
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {WebPortalIndustryAutomative}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Automotive</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {WebPortalIndustryFintech}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Fintech</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {WebPortalIndustryCann}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Cannabies</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {EcommerceWebIndustryHealthcare}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Healthcare</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {WebPortalIndustryHospitality}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Hospitality</h5>
                </div>
              </div>
              <div className="ecommerce_indus_item">
                <div className="ecommerce_indus_icon">
                  {WebPortalIndustryInsurance}
                </div>
                <div className="ecommerce_indus_head">
                  <h5>Insurance</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ecommerceindustries;
